import {Request} from './Request';
import {ConfigurationKeys} from '../enums/config.keys.enum';

/**
 *
 */
export class GetConfigurationRequest implements Request {
    chargePointSelectList: string[];
    private confKeyList: ConfigurationKeys[];
    private commaSeparatedCustomConfKeys: string;
    private getConfigurationValue:string

    constructor(chargePointSelectList: string[], confKeyList?: ConfigurationKeys[], commaSeparatedCustomConfKeys?: string, getConfigurationValue?: string) {
        this.chargePointSelectList = chargePointSelectList;
        this.confKeyList = confKeyList;
        this.commaSeparatedCustomConfKeys = commaSeparatedCustomConfKeys;
        this.getConfigurationValue = getConfigurationValue;
    }

    public toString = (): string => {
        return `GetConfigurationRequest (chargePointSelectList: ${this.chargePointSelectList},
        confKeyList: ${this.confKeyList}, commaSeparatedCustomConfKeys: ${this.commaSeparatedCustomConfKeys}, getConfigurationValue: ${this.getConfigurationValue} `;
    }


    get conf_key_list(): ConfigurationKeys[] {
        return this.confKeyList;
    }

    set conf_key_list(value: ConfigurationKeys[]) {
        this.confKeyList = value;
    }

    get _commaSeparatedCustomConfKeys(): string {
        return this.commaSeparatedCustomConfKeys;
    }

    set _commaSeparatedCustomConfKeys(value: string) {
        this.commaSeparatedCustomConfKeys = value;
    }

    get _getConfigurationValue(): string{
        return this.getConfigurationValue;
    }

    set _getConfigurationValue(value: string) {
        this.getConfigurationValue = value;
    }
}

/*

chargePointSelectList: JSON;EVB-P20261797;-
chargePointSelectList: 1
confKeyList: AllowOfflineTxForUnknownId
confKeyList: AuthorizationCacheEnabled
confKeyList: 1
commaSeparatedCustomConfKeys: key1,key2
csrf: 7f448777-54a3-4050-8ec1-9c696b0d47ef
 */
